//import("https://cdn.shopify.com/s/javascripts/currencies.js");

(function (window) {
  const dhlZones = new Map(Object.entries({
    "1": ["DE", "IT", "IT", "IT", "HR", "SK", "SI", "CZ", "HU", "VA"],
    "2": ["BE", "FR", "GB", "LU", "MC", "NL"],
    "3": ["BG", "DK", "EE", "FI", "FI", "GR", "GR", "IE", "LV", "LT", "MT", "PL", "PT", "RO", "SE", "ES", "ES", "ES", "CY"],
    "4": ["LI", "CH"],
    "5": ["AL", "AD", "BA", "FO", "GI", "GL", "GG", "IS", "JE", "XK", "MD", "ME", "MK", "NO", "SM", "RS", "TR", "UA", "IC"],
    "6": ["CA", "MX", "US"],
    "7": ["HK", "CN", "IN", "ID", "JP", "KH", "LA", "MY", "SG", "TW", "TH", "VN"],
    "8": ["EG", "DZ", "AO", "AI", "AG", "GQ", "AR", "AW", "ET", "AU", "BS", "BH", "BD", "BB", "BZ", "BJ", "BM", "BT", "BO", "BW", "BR", "VG", "BN", "BF", "BI", "CL", "MO", "CK", "CR", "CW", "DM", "DO", "DJ", "EC", "SV", "ER", "SZ", "FK", "FJ", "GF", "GA", "GM", "GH", "GD", "GP", "GT", "GN", "GW", "GY", "HT", "HN", "IL", "JM", "JO", "KY", "CM", "QA", "KE", "KI", "CO", "KM", "CG", "KR", "CU", "KW", "LS", "MG", "MW", "MV", "MA", "MH", "MQ", "MR", "MU", "YT", "FM", "MN", "MS", "MZ", "NA", "NR", "NP", "NC", "NZ", "NI", "NG", "NU", "OM", "PK", "PW", "PA", "PG", "PY", "PE", "PH", "RE", "RW", "SB", "ZM", "WS", "ST", "SA", "SN", "SC", "SL", "SX", "LK", "KN", "SH", "LC", "VC", "ZA", "SR", "TZ", "TL", "TG", "TO", "TT", "TD", "TN", "TC", "TV", "UG", "UY", "VU", "AE", "MP", "XN", "GU", "VI", "PR", "XS", "XY", "XE", "PF"],
    "9": ["AF", "AM", "AZ", "BY", "CI", "GE", "IQ", "IR", "YE", "KZ", "KG", "CD", "KP", "LB", "LR", "LY", "ML", "MM", "NE", "RU", "ZW", "SO", "SD", "SS", "SY", "TJ", "TM", "UZ", "VE", "CF"],
    "Austria": ["AT"]
  }));

  const postZones = new Map(Object.entries({
    "Germany": ["DE"],
    "1a": ["HR", "PL", "SK", "SI", "CZ", "HU"],
    "1b": ["BE", "BG", "EE", "FI", "FI", "FR", "IT", "LT", "LU", "MC", "NL", "RO"],
    "1c": ["DK", "GR", "GR", "IE", "LV", "MT", "PT", "SE", "ES", "ES", "ES", "CY"],
    "2": ["EG", "AL", "DZ", "AD", "AM", "AZ", "BY", "BA", "FO", "GE", "GI", "GL", "GB", "IS", "IL", "XK", "LB", "LY", "LI", "MA", "MD", "ME", "MK", "NO", "RU", "SM", "CH", "RS", "SY", "TN", "TR", "UA", "VA"],
    "3": ["ET", "BH", "BJ", "BF", "CI", "DJ", "ER", "GM", "GH", "GN", "GW", "IQ", "IR", "YE", "JO", "CM", "CA", "KZ", "QA", "KG", "KW", "LR", "ML", "MH", "MR", "FM", "NE", "NG", "OM", "PW", "SA", "SN", "SL", "SO", "SD", "SS", "TJ", "TG", "TD", "TM", "UZ", "AE", "CF"],
    "4": ["AF", "AO", "AI", "AG", "GQ", "AR", "AW", "BS", "BD", "BB", "BZ", "BM", "BT", "BO", "BW", "BR", "VG", "BN", "BI", "CL", "HK", "MO", "CN", "CR", "CW", "DM", "DO", "EC", "SV", "SZ", "FK", "GF", "GA", "GD", "GP", "GT", "GG", "GY", "HT", "HN", "IN", "ID", "JM", "JP", "JE", "KY", "KH", "KE", "CO", "KM", "CD", "CG", "KP", "KR", "CU", "LA", "LS", "MG", "MW", "MY", "MV", "MQ", "MU", "YT", "MX", "MN", "MS", "MZ", "MM", "NA", "NP", "NI", "PK", "PA", "PY", "PE", "PH", "RE", "RW", "ZM", "ST", "SC", "ZW", "SG", "SX", "LK", "KN", "SH", "LC", "VC", "ZA", "SR", "TW", "TZ", "TH", "TL", "TT", "TC", "UG", "UY", "VE", "VN"],
    "5": ["AU", "CK", "FJ", "KI", "NR", "NC", "NZ", "NU", "PG", "SB", "WS", "TO", "TV", "VU"],
    "Austria": ["AT"],
    "US PDDP": ["US"]
  }));

  const dhlPrices = new Map(Object.entries({
    "1": { "2": 24.61, "2.5": 25.60, "3": 26.59, "3.5": 27.58, "4": 28.57, "4.5": 29.56, "5": 30.55, "5.5": 31.79, "6": 33.03, "6.5": 34.27, "7": 35.51, "7.5": 36.75, "8": 37.99, "8.5": 39.23, "9": 40.47, "9.5": 41.71, "10": 42.95, "11": 46.05, "12": 49.15, "13": 52.25, "14": 55.35, "15": 58.45, "16": 61.55, "17": 64.65, "18": 67.75, "19": 70.85, "20": 73.95, "21": 77.05, "22": 80.15, "23": 83.25, "24": 86.35, "25": 89.45, "26": 92.55, "27": 95.65, "28": 98.75, "29": 101.85, "30": 104.95, "40": 145.15, "50": 185.35, "60": 225.55, "70": 265.75 },
    "2": { "2": 26.47, "2.5": 28.02, "3": 29.57, "3.5": 31.12, "4": 32.67, "4.5": 34.22, "5": 35.77, "5.5": 37.32, "6": 38.87, "6.5": 40.42, "7": 41.97, "7.5": 43.52, "8": 45.07, "8.5": 46.62, "9": 48.17, "9.5": 49.72, "10": 51.27, "11": 54.37, "12": 57.47, "13": 60.57, "14": 63.67, "15": 66.77, "16": 69.87, "17": 72.97, "18": 76.07, "19": 79.17, "20": 82.27, "21": 85.37, "22": 88.47, "23": 91.57, "24": 94.67, "25": 97.77, "26": 100.87, "27": 103.97, "28": 107.07, "29": 110.17, "30": 113.27, "40": 153.47, "50": 193.67, "60": 233.87, "70": 274.07 },
    "3": { "2": 26.47, "2.5": 28.02, "3": 29.57, "3.5": 31.12, "4": 32.67, "4.5": 34.22, "5": 35.77, "5.5": 37.32, "6": 38.87, "6.5": 40.42, "7": 41.97, "7.5": 43.52, "8": 45.07, "8.5": 46.62, "9": 48.17, "9.5": 49.72, "10": 51.27, "11": 54.37, "12": 57.47, "13": 60.57, "14": 63.67, "15": 66.77, "16": 69.87, "17": 72.97, "18": 76.07, "19": 79.17, "20": 82.27, "21": 85.37, "22": 88.47, "23": 91.57, "24": 94.67, "25": 97.77, "26": 100.87, "27": 103.97, "28": 107.07, "29": 110.17, "30": 113.27, "40": 153.47, "50": 193.67, "60": 233.87, "70": 274.07 },
    "4": { "2": 29.58, "2.5": 31.31, "3": 33.04, "3.5": 34.77, "4": 36.50, "4.5": 38.23, "5": 39.96, "5.5": 41.69, "6": 43.42, "6.5": 45.15, "7": 46.88, "7.5": 48.61, "8": 50.34, "8.5": 52.07, "9": 53.8, "9.5": 55.53, "10": 57.26, "11": 60.72, "12": 64.18, "13": 67.64, "14": 71.1, "15": 74.56, "16": 78.02, "17": 81.48, "18": 84.94, "19": 88.4, "20": 91.86, "21": 95.32, "22": 98.78, "23": 102.24, "24": 105.7, "25": 109.16, "26": 112.62, "27": 116.08, "28": 119.54, "29": 123, "30": 126.46, "40": 166.66, "50": 206.86, "60": 247.06, "70": 287.26 },
    "5": { "2": 33.22, "2.5": 35.07, "3": 36.92, "3.5": 38.77, "4": 40.62, "4.5": 42.47, "5": 44.32, "5.5": 46.17, "6": 48.02, "6.5": 49.87, "7": 51.72, "7.5": 53.57, "8": 55.42, "8.5": 57.27, "9": 59.12, "9.5": 60.97, "10": 62.82, "11": 66.52, "12": 70.22, "13": 73.92, "14": 77.62, "15": 81.32, "16": 85.02, "17": 88.72, "18": 92.42, "19": 96.12, "20": 99.82, "21": 103.52, "22": 107.22, "23": 110.92, "24": 114.62, "25": 118.32, "26": 122.02, "27": 125.72, "28": 129.42, "29": 133.12, "30": 136.82, "40": 177.02, "50": 217.22, "60": 257.42, "70": 297.62 },
    "6": { "2": 40.53, "2.5": 43.00, "3": 45.47, "3.5": 47.94, "4": 50.41, "4.5": 52.88, "5": 55.35, "5.5": 59.05, "6": 62.75, "6.5": 66.45, "7": 70.15, "7.5": 73.85, "8": 77.55, "8.5": 81.25, "9": 84.95, "9.5": 88.65, "10": 92.35, "11": 98.51, "12": 104.67, "13": 110.83, "14": 116.99, "15": 123.15, "16": 129.31, "17": 135.47, "18": 141.63, "19": 147.79, "20": 153.95, "21": 160.11, "22": 166.27, "23": 172.43, "24": 178.59, "25": 184.75, "26": 190.91, "27": 197.07, "28": 203.23, "29": 209.39, "30": 215.55, "40": 289.65, "50": 363.75, "60": 437.85, "70": 511.95 },
    "7": { "2": 46.79, "2.5": 49.44, "3": 52.09, "3.5": 54.74, "4": 57.39, "4.5": 60.04, "5": 62.69, "5.5": 66.71, "6": 70.73, "6.5": 74.75, "7": 78.77, "7.5": 82.79, "8": 86.81, "8.5": 90.83, "9": 94.85, "9.5": 98.87, "10": 102.89, "11": 109.69, "12": 116.49, "13": 123.29, "14": 130.09, "15": 136.89, "16": 143.69, "17": 150.49, "18": 157.29, "19": 164.09, "20": 170.89, "21": 177.69, "22": 184.49, "23": 191.29, "24": 198.09, "25": 204.89, "26": 211.69, "27": 218.49, "28": 225.29, "29": 232.09, "30": 238.89, "40": 318.99, "50": 399.09, "60": 479.19, "70": 559.29 },
    "8": { "2": 54.61, "2.5": 57.39, "3": 60.17, "3.5": 62.95, "4": 65.73, "4.5": 68.51, "5": 71.29, "5.5": 75.23, "6": 79.17, "6.5": 83.11, "7": 87.05, "7.5": 90.99, "8": 94.93, "8.5": 98.87, "9": 102.81, "9.5": 106.75, "10": 110.69, "11": 118.09, "12": 125.49, "13": 132.89, "14": 140.29, "15": 147.69, "16": 155.09, "17": 162.49, "18": 169.89, "19": 177.29, "20": 184.69, "21": 192.09, "22": 199.49, "23": 206.89, "24": 214.29, "25": 221.69, "26": 229.09, "27": 236.49, "28": 243.89, "29": 251.29, "30": 258.69, "40": 344.99, "50": 431.29, "60": 517.59, "70": 603.89 },
    "9": { "2": 62.79, "2.5": 65.87, "3": 68.95, "3.5": 72.03, "4": 75.11, "4.5": 78.19, "5": 81.27, "5.5": 85.59, "6": 89.91, "6.5": 94.23, "7": 98.55, "7.5": 102.87, "8": 107.19, "8.5": 111.51, "9": 115.83, "9.5": 120.15, "10": 124.47, "11": 133.11, "12": 141.75, "13": 150.39, "14": 159.03, "15": 167.67, "16": 176.31, "17": 184.95, "18": 193.59, "19": 202.23, "20": 210.87, "21": 219.51, "22": 228.15, "23": 236.79, "24": 245.43, "25": 254.07, "26": 262.71, "27": 271.35, "28": 279.99, "29": 288.63, "30": 297.27, "40": 395.97, "50": 494.67, "60": 593.37, "70": 692.07 },
    "Austria": { "30": 10.25, "40.0": 16.75, "50.0": 24.75, "60.0": 33.75, "70.0": 43.75 }
  }));

  const postPrices = new Map(Object.entries({
    "1a": { "2": 9.9, "4": 11, "8": 13.9, "12": 17, "31.5": 21 },
    "1b": { "2": 11.9, "4": 14, "8": 17.3, "12": 20.9, "31.5": 25.7 },
    "1c": { "2": 13.3, "4": 17.5, "8": 22.9, "12": 31.7, "31.5": 51.5 },
    "2": { "2": 17.6, "4": 20.3, "8": 26.9, "12": 36, "31.5": 60.8 },
    "3": { "2": 23.8, "4": 36.7, "8": 55.3, "12": 95.3, "31.5": 170.9 },
    "4": { "2": 27.3, "4": 41.9, "8": 62.3, "12": 105.4, "31.5": 188 },
    "5": { "2": 33, "4": 52.7, "8": 84.7, "12": 128.3, "31.5": 275 },
    "Germany": { "2": 8.7, "4": 9.9, "8": 12.5, "12": 15.5, "31.5": 18.6 },
    "Austria": { "2": 8.7, "4": 9.9, "8": 12.5, "12": 15.5, "31.5": 18.6 },
    "US PDDP": { "2": 29.3, "4": 43.9, "8": 64.3, "12": 107.4, "31.5": 190 }
  }));

  const freeShipping = new Map(Object.entries({
    "14": 250,
    "18": 285,
    "24": 300,
    "31": 325,
    "42": 350,
    "52": 420
  }));

const eu_countries = [
    "AT",  // Austria
    "BE",  // Belgium
    "BG",  // Bulgaria
    "HR",  // Croatia
    "CY",  // Cyprus
    "CZ",  // Czech Republic
    "DK",  // Denmark
    "EE",  // Estonia
    "FI",  // Finland
    "FR",  // France
    "DE",  // Germany
    "GR",  // Greece
    "HU",  // Hungary
    "IE",  // Ireland
    "IT",  // Italy
    "LV",  // Latvia
    "LT",  // Lithuania
    "LU",  // Luxembourg
    "MT",  // Malta
    "NL",  // Netherlands
    "PL",  // Poland
    "PT",  // Portugal
    "RO",  // Romania
    "SK",  // Slovakia
    "SI",  // Slovenia
    "ES",  // Spain
    "SW",  // Sweden
];

  function getPrice(zones, prices, country, weight) {
    let zone = NaN;
    console.log("calculating price for country=" + country + ", weight=" + weight + "...");
    for (const [_zone, countries] of zones.entries()) {
      if (countries.includes(country)) {
        zone = _zone;
        break;
      }
    }
    console.log("\tzone=" + zone)

    let price = NaN;
    const zone_prices = new Map(Object.entries(prices.get(zone)).sort((a, b) => parseFloat(a[1]) - parseFloat(b[1])));
    for (const [weight_str, _price] of zone_prices.entries()) {
      if (parseFloat(weight) < parseFloat(weight_str)) {
        price = _price;
        break;
      }
    }
    console.log("\tBase Price=" + price)

    /*if (eu_countries.includes(country)) {
      price = price * (1.0 + 0.2)
      console.log("\t" + country + " is in EU: Price=" + price);
    } else {
      console.log("\t" + country + " is not in EU: Price=" + price);
    }*/
   price = price * (1.0 + 0.2)
   console.log("\tadd VAT, Price=" + price)

    console.log("\tfinal price:" + price);
    return price;
  }

  function estimate(country_iso, currency_iso, weight) {
    console.log("estimate(" + country_iso + " , " + currency_iso + ", " + weight + ")");

    let dhl_price = getPrice(dhlZones, dhlPrices, country_iso, weight);
    let post_price = getPrice(postZones, postPrices, country_iso, weight);

    let price = NaN;
    if (dhl_price >= post_price) {
      price = post_price;
      console.log("best price is via Post: " + price + " EUR")
    } else {
      price = dhl_price;
      console.log("best price is via DHL: " + price + " EUR")
    }

    let threshold = NaN;
    for (const [max_price, _threshold] of freeShipping.entries()) { // todo: should make sure this is sorted
      if (parseFloat(max_price) > price) {
        threshold = _threshold;
        break;
      }
    }

    console.log("Threshold: " + threshold + " EUR");
    console.log("Price: " + price + " EUR");

    let price_local = Currency.convert(price, "EUR", currency_iso);
    let threshold_local = Currency.convert(threshold, "EUR", currency_iso);

    if (currency_iso !== "EUR") {
      price_local = Math.ceil(price_local)
      threshold_local = Math.ceil(threshold_local)
    }

    return {
      price: price_local,
      threshold: threshold_local,
    };
  }

  window.SwitchologyShipping = {
    calculateShipping: estimate
  };
})(window);